
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Alert from 'vux/src/components/alert/index.vue'


export default {
components: {
Group,
XInput,
XHeader,
XButton,
Toast,
Selector,
Alert
},
name: 'singleSkill',
data () {
return {
list1: ['存储', '网络', '服务器/工作站', '数据库', '中间件', '云计算', 'Harmonic', 'ROSS', '其他IT专业'],
superClass: '存储',
list2: ['精一F1S2000', '精一F1S3000', '精一F1S5000', '精一F1S9000', '精一云汉', '精一海德/领航'],
subClass1: '精一F1S2000',
selisShow: true,
inputisShow: false,
subClass: ''
}
},
methods: {
addSkill () {
var spec = {
'superClass': this.superClass,
'subClass': ''
}
spec.subClass = this.selisShow ? this.subClass1 : this.subClass2
var quit = false
let expertdata = localStorage.getItem('expertdata')
if (expertdata != null) {
var data = JSON.parse(expertdata)
if (data.speciality === null) {
data.speciality = []
}
for (var i = 0; i < data.speciality.length; i++) {
if ((spec.superClass === data.speciality[i].superClass) && (spec.subClass === data.speciality[i].subClass)) {
quit = true
this.$vux.alert.show({
title: '',
content: '专业特长已存在，不能重复添加'
})
break
}
}
if (quit) {
return
}
data.speciality.push(spec)
expertdata = JSON.stringify(data)
localStorage.setItem('expertdata', expertdata)
}
this.$router.push({name: 'skill'})
},
superclassChange (val) {
switch (val) {
case '存储':
this.list2 = ['精一F1S2000', '精一F1S3000', '精一F1S5000', '精一F1S9000', '精一云汉', '精一海德/领航']
this.subClass1 = '精一F1S2000'
this.selisShow = true
this.inputisShow = false
break
case '网络':
this.list2 = ['H3C盒式交换机', '锐捷盒式交换机']
this.subClass1 = 'H3C盒式交换机'
this.selisShow = true
this.inputisShow = false
break
case '服务器/工作站':
this.list2 = ['精一云际']
this.subClass1 = '精一云际'
this.selisShow = true
this.inputisShow = false
break
case '数据库':
this.list2 = ['微软SQLServer', '甲骨文Oracle', 'IBM DB2']
this.subClass1 = '微软SQLServer'
this.selisShow = true
this.inputisShow = false
break
case '中间件':
this.list2 = ['Apache/Tomcat']
this.subClass1 = 'Apache/Tomcat'
this.selisShow = true
this.inputisShow = false
break
case '云计算':
this.list2 = ['Vmware vSphere']
this.subClass1 = 'Vmware vSphere'
this.selisShow = true
this.inputisShow = false
break
case 'Harmonic':
this.list2 = ['视频服务器']
this.subClass1 = '视频服务器'
this.selisShow = true
this.inputisShow = false
break
case 'ROSS':
this.list2 = ['视频服务器', '矩阵及周边']
this.subClass1 = '视频服务器'
this.selisShow = true
this.inputisShow = false
break
case '其他IT专业':
this.selisShow = false
this.inputisShow = true


break








default:
break
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/singleSkill.vue